var _excluded = ["css", "height", "width", "borderColor", "iconProps", "onClick", "onChange", "onBlur", "onFocus", "disabled", "name", "required", "checked", "variant", "label", "containerProps", "id", "value", "labelPosition", "uncheckedValue", "checkedValue", "selectEntireTile", "labelProps", "spanInputProps"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) { symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); } keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import { Label, Span } from '@kizi/core-components';
import React, { useMemo } from 'react';
import { IconV2 as Icon } from '../components/IconV2';
var inputStyle = {
  position: 'absolute',
  opacity: 0,
  cursor: 'pointer',
  height: '100%',
  width: '100%',
  zIndex: 9
};
var baseIconProps = {
  name: 'check',
  height: '100%',
  width: '100%'
};
export var Checkbox = function Checkbox(_ref) {
  var css = _ref.css,
      _ref$height = _ref.height,
      height = _ref$height === void 0 ? 20 : _ref$height,
      _ref$width = _ref.width,
      width = _ref$width === void 0 ? 20 : _ref$width,
      _ref$borderColor = _ref.borderColor,
      borderColor = _ref$borderColor === void 0 ? 'second.0' : _ref$borderColor,
      iconProps = _ref.iconProps,
      onClick = _ref.onClick,
      _onChange = _ref.onChange,
      onBlur = _ref.onBlur,
      onFocus = _ref.onFocus,
      disabled = _ref.disabled,
      name = _ref.name,
      required = _ref.required,
      checked = _ref.checked,
      variant = _ref.variant,
      label = _ref.label,
      containerProps = _ref.containerProps,
      id = _ref.id,
      value = _ref.value,
      _ref$labelPosition = _ref.labelPosition,
      labelPosition = _ref$labelPosition === void 0 ? 'left' : _ref$labelPosition,
      _ref$uncheckedValue = _ref.uncheckedValue,
      uncheckedValue = _ref$uncheckedValue === void 0 ? 'no_value' : _ref$uncheckedValue,
      _ref$checkedValue = _ref.checkedValue,
      checkedValue = _ref$checkedValue === void 0 ? 'default' : _ref$checkedValue,
      _ref$selectEntireTile = _ref.selectEntireTile,
      selectEntireTile = _ref$selectEntireTile === void 0 ? false : _ref$selectEntireTile,
      labelProps = _ref.labelProps,
      spanInputProps = _ref.spanInputProps,
      spanProps = _objectWithoutProperties(_ref, _excluded);

  var checkmarkStyle = useMemo(function () {
    return _objectSpread({
      borderStyle: 'solid',
      borderWidth: '1px',
      display: 'inline-block',
      position: 'relative',
      cursor: 'pointer',
      userSelect: 'none',
      height: height,
      width: width
    }, css);
  }, [width, height, css]);

  var _iconProps = _objectSpread(_objectSpread({}, baseIconProps), iconProps);

  var isChecked = useMemo(function () {
    return checked || value === checkedValue;
  }, [checked, value, checkedValue]);
  var containerCheckboxVariant = "inputs.checkboxes.".concat(variant).concat(isChecked ? '.tileChecked' : '.tileUnchecked');
  var checkboxVariant = "inputs.checkboxes.".concat(variant).concat(isChecked ? '.checked' : '');
  var checkboxVariantDisabled = "inputs.checkboxes.".concat(variant).concat(disabled ? '.disabled' : '');

  var _id = useMemo(function () {
    return id && !id.includes('undefined') ? id : "".concat(label === null || label === void 0 ? void 0 : label.toString().toLowerCase().replace(/\s/g, ''), "-").concat(Math.floor(Math.random() * 100));
  }, [label]);

  var clonedLabel = /*#__PURE__*/React.isValidElement(label) ? /*#__PURE__*/React.cloneElement(label, _objectSpread(_objectSpread({}, label.props), {}, {
    htmlFor: _id
  })) : label;

  var _label = useMemo(function () {
    return typeof label === 'string' ? /*#__PURE__*/React.createElement(Label, _extends({}, labelProps, {
      htmlFor: _id,
      variant: "radioGroupItemLabel",
      "data-testid": "checkbox-label",
      dangerouslySetInnerHTML: {
        __html: label
      },
      css: disabled ? {
        color: 'second.0'
      } : null
    })) : clonedLabel;
  }, [label]);

  return /*#__PURE__*/React.createElement(Span, _extends({
    display: "flex"
  }, containerProps, {
    variant: variant === 'tile' ? containerCheckboxVariant : '',
    onClick: selectEntireTile ? onClick : undefined
  }), labelPosition === 'left' && _label, /*#__PURE__*/React.createElement(Span, _extends({
    minWidth: width
  }, spanProps, {
    css: checkmarkStyle,
    variant: disabled ? checkboxVariantDisabled : checkboxVariant
  }), /*#__PURE__*/React.createElement("input", {
    "data-testid": "checkbox-input",
    type: "checkbox",
    style: inputStyle,
    onChange: function onChange(e) {
      if (_onChange) {
        _onChange(_objectSpread(_objectSpread({}, e), {}, {
          target: _objectSpread(_objectSpread({}, e.target), {}, {
            name: e.target.name,
            value: e.target.checked ? checkedValue : uncheckedValue
          })
        }));
      }
    },
    onClick: onClick,
    onBlur: onBlur,
    onFocus: onFocus,
    disabled: disabled,
    name: name,
    required: required,
    checked: isChecked,
    id: _id
  }), /*#__PURE__*/React.createElement(Span, _extends({
    position: "absolute",
    top: 0,
    left: 0,
    height: "100%",
    width: "100%"
  }, spanInputProps), isChecked && /*#__PURE__*/React.createElement(Icon, _iconProps))), labelPosition === 'right' && _label);
};